import styled from 'styled-components';
import { Grid } from 'syf-component-library/ui/patterns';
export const Image = styled.img `
  max-width: 100%;
  max-height: 100%;
`;
// export const ImageContainer = styled.div` // src/ui/molecules/PaymentModalStates/subcomponents.tsx
// src/ui/molecules/PaymentMethods/
export const ImageContainer = styled(Grid) ` 
PaymentMethodForm/subcomponents.tsx
  width: 100%;
  display: flex;
  justify-content: center;
`;
